import { Directive, EventEmitter, Input, Output, ElementRef, Renderer2 } from '@angular/core';
import { InterpolateService, InterpolationOptions } from '../../services/interpolate.service';

@Directive({
  selector: '[genInterpolator]'
})
export class InterpolatorDirective {

  @Output() interpolatorChanged: EventEmitter<string> = new EventEmitter();
  private _values: { [p: string]: string } | string[];
  private _textNode: any;

  @Input()
  private interpolationOptions: InterpolationOptions = { useEmptyValues: false, clearUnresolvedPatterns: false, usePartialPath: true};
  @Input()
  set values(values: { [prop: string]: string } | string[]) {
    this._values = values;
    this.interpolate();
  }
  get values() {
    return this._values;
  }
  @Input() overrideContent: boolean = true;
  private _interpolationString: string;

  @Input('genInterpolator')
  set genInterpolator(interpolationString: string) {
    this._interpolationString = interpolationString;
    this.interpolate();
  }
  get genInterpolator() {
    return this.interpolatedString;
  }

  public set interpolatedString(interpolatedString: string) {
    this.interpolatorChanged.emit(interpolatedString);
    if (this._textNode) {
      this._renderer.removeChild(this.element.nativeElement, this._textNode);
    } else {
      this.element.nativeElement.innerText = '';
    }
    if (this.overrideContent && interpolatedString) {
      this._textNode = this._renderer.createText(interpolatedString);
      this._renderer.appendChild(this.element.nativeElement, this._textNode);
    }
  }

  constructor(
    private interpolator: InterpolateService,
    private element: ElementRef,
    private _renderer: Renderer2
  ) { }

  private interpolate() {
    if (this._interpolationString && this.values) {
      this.interpolatedString = this.interpolator.interpolate(this._interpolationString, this.values, false, this.interpolationOptions);
    }
  }
}
